import { EField } from "./schema.createNote.types";
export var getInitialValues = function (_a) {
    var _b;
    var content = _a.content;
    return _b = {},
        _b[EField.Content] = content,
        _b;
};
